import { useEffect, useMemo, useReducer, useState } from "react"
import {
    COLORS,
    generateBodyPitch,
    generateConfigData,
    generateMeshPoints,
} from '@/config/mesh_map'
import LocalDressupComponents from '@/assets/AppAssets/edit_item_list.json'
import { RESOURCE_MANAGER } from "@/config"
export const dataSourceReducer = (state, action) => {
    const faceData = state.find(item => item.name === 'face')
    const bodyData = state.find(item => item.name === 'body')
    const clothesData = state.find(item => item.name === 'clothes')
    const { name, selected } = action.data
    switch (action.type) {
        case 'init':
            return action.data
        case 'face':
            faceData.types.forEach((item) => {
                if (item.name === name) {
                    item.selected = selected
                }
            })
            return [
                faceData,
                bodyData,
                clothesData
            ]
        case 'body':
            bodyData.types.forEach((item) => {
                if (item.name === name) {
                    item.selected = selected
                }
            })
            return [
                faceData,
                bodyData,
                clothesData
            ]
        case 'clothes':
            clothesData.types.forEach((item) => {
                if (item.name === name) {
                    item.selected = selected
                }
            })
            return [
                faceData,
                bodyData,
                clothesData
            ]
        default:
            console.error('unkonw action ', action)
    }
}
export function useAvatarEdit(
    local,
    initDressupType,
    avatarConfig,
) {
    const [dressupComponents, setDressupComponents] = useState({})

    const [controlData, setControlData] = useState<any[]>([])
    const [selectedDressupPart, setSelectedDressupPart] = useState('my')
    const [activeCollapsePanels, setActiveCollapsePanels] = useState(['1'])
    const [selectedDressupType, setSelectedDressupType] = useState(initDressupType)
    const [selectedTypeInCurrentPart, setSelectedTypeInCurrentPart] = useState<any>({})

    const [meshPoints, setMeshPoints] = useState<any>({})
    const [bodyPitchs, setBodyPitchs] = useState({})
    const [tableData, dispatchTableData] = useReducer(
        dataSourceReducer,
        []
    )
    const faceData = useMemo(() => {
        return tableData.find(item => item.name === 'face') || {}
    }, [tableData])
    const bodyData = useMemo(() => {
        return tableData.find(item => item.name === 'body') || {}
    }, [tableData])
    const clothesData = useMemo(() => {
        return tableData.find(item => item.name === 'clothes') || {}
    }, [tableData])

    useEffect(() => {
        if (avatarConfig?.data) {
            setSelectedDressupPart('my')
            const controlDataDraft = generateConfigData(
                avatarConfig?.data.color_list,
                avatarConfig?.data.bundle_list,
                avatarConfig?.data.bodyShape
            )
            setControlData(controlDataDraft)
            dispatchTableData({ type: 'init', data: controlDataDraft })
            const meshPointsDraft = generateMeshPoints(
                avatarConfig?.data.facepup_config
            )
            setMeshPoints(meshPointsDraft)
            const bodyPitchsDraft = generateBodyPitch(
                avatarConfig?.data.facepup_config
            )
            setBodyPitchs(bodyPitchsDraft)
        }
    }, [avatarConfig?.data])

    const gender = useMemo(() => avatarConfig?.data.gender, [avatarConfig?.data])
    const selectedPartInControlData = useMemo(() => {
        setActiveCollapsePanels(['1'])
        return controlData?.find(
            (item) => item.name === selectedDressupPart
        )?.types?.filter((item) =>
            item.gender.includes(gender)
        ) || []
    }, [controlData, selectedDressupPart, gender])

    useEffect(() => {
        void (async () => {
            if (!RESOURCE_MANAGER.dressupComponents) return
            const dressupComponentsDraft: Record<string, any> = {}
            for (let [key, value] of Object.entries(
                local ? LocalDressupComponents.map : RESOURCE_MANAGER.dressupComponents
            )) {
                dressupComponentsDraft[key] = (value as unknown as any).filter(
                    (item) => item.filter?.gender === gender
                );
            }
            dressupComponentsDraft.body = [{
                index: 5,
                icon_url: 'slices/fu_five_head_body.png',
                name: '五头身'
            }, {
                index: 6,
                icon_url: 'slices/fu_six_head_body.png',
                name: '六头身'
            }, {
                index: 7,
                icon_url: 'slices/fu_seven_head_body.png',
                name: '七头身'
            }, {
                index: 8,
                icon_url: 'slices/fu_eight_head_body.png',
                name: '八头身'
            }, {
                index: 9,
                icon_url: 'slices/fu_nine_head_body.png',
                name: '九头身'
            }]
            setDressupComponents(dressupComponentsDraft)
            setSelectedDressupType(initDressupType)
        })()
    }, [gender])

    useEffect(() => {
        if (selectedDressupPart === 'clothes') {
            setSelectedDressupType('shirt')
        } else {
            setSelectedDressupType(selectedPartInControlData?.[0]?.name)
        }
        setSelectedTypeInCurrentPart(selectedPartInControlData.find(
            (item) => item.name === selectedPartInControlData?.[0]?.name
        ))
    }, [selectedPartInControlData])
    const currentItems = useMemo(() => {
        return selectedDressupType
            ? dressupComponents[selectedDressupType] || COLORS[selectedDressupType] || []
            : []
    }, [selectedDressupType])

    const currentFacepup = useMemo(() => {
        return selectedDressupType &&
            selectedTypeInCurrentPart?.facepup
            ? selectedTypeInCurrentPart.facepup
            : [];
    }, [selectedDressupType, selectedTypeInCurrentPart])

    function handleTypeSelect(type) {
        setActiveCollapsePanels(['1'])
        setSelectedDressupType(type)
        const selectedTypeInCurrentPartDraft = selectedPartInControlData?.find(
            (item) => item.name === type
        )
        setSelectedTypeInCurrentPart(selectedTypeInCurrentPartDraft)
    }
    return {
        currentItems,
        gender,
        controlData,
        meshPoints,
        bodyPitchs,
        faceData,
        bodyData,
        clothesData,
        selectedPartInControlData,
        selectedDressupType,
        selectedTypeInCurrentPart,
        currentFacepup,
        setSelectedTypeInCurrentPart,
        setMeshPoints,
        setBodyPitchs,
        setSelectedDressupType,
        dispatchTableData,
        selectedDressupPart,
        setSelectedDressupPart,
        activeCollapsePanels,
        setActiveCollapsePanels,
        handleTypeSelect,
    }
}